import React, { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import AuthService from "../services/auth/AuthService";
import { useLocation } from "react-router-dom";

const RestrictedComponent = ({ component: Component, redirectPath, ...rest }) => {
  const [needsLogin, setNeedsLogin] = useState(false);

  const location = useLocation();

  useEffect(() => {
    if (AuthService.getCurrentUser()) {
      setNeedsLogin(false);
    } else {
      setNeedsLogin(true);
    }
    // }
  }, [location]);

  return (
    <Route
      {...rest}
      // onEnter={checkLoginStatus}
      render={(props) =>
        !needsLogin ? (
          // console.log("heard")
          <Component {...props} />
        ) : (
          //  console.log("heard")
          // <Component {...props} />
          <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
        )
      }
    />
  );
};

export default RestrictedComponent;
